export enum TcddMainSystem {
  DIAGNOSTIC_SYSTEM = 'diagnosticSystem',
  PROGNOSTIC_SYSTEM = 'prognosticSystem'
}
